import { supabase } from '@/lib/supabase';

/**
 * İletişim formu gönderimi
 * @param {Object} formData - Form verileri
 * @param {string} formData.name - Tam adı
 * @param {string} formData.email - E-posta
 * @param {string} formData.phone - Telefon (opsiyonel)
 * @param {string} formData.subject - Konu (opsiyonel)
 * @param {string} formData.message - Mesaj
 * @param {string} formData.propertyId - İlgili gayrimenkul ID (opsiyonel)
 * @param {string} formData.inquiryType - general | property | investment
 * @param {string} formData.language - Dil kodu (en, tr, ar, ru)
 * @returns {Promise<Object>} Oluşturulan inquiry kaydı
 */
export async function submitContactForm(formData) {
  try {
    const { data, error } = await supabase
      .from('contact_inquiries')
      .insert([{
        full_name: formData.name,
        email: formData.email,
        phone: formData.phone || null,
        subject: formData.subject || null,
        message: formData.message,
        property_id: formData.propertyId || null,
        inquiry_type: formData.inquiryType || 'general',
        language: formData.language || 'en',
        status: 'new'
      }])
      .select()
      .single();
    
    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error submitting contact form:', error);
    throw error;
  }
}
